import { GROUPS_DUMMY } from "../../../../../constants/peopleData";
import { mapApiGroupToDetailView } from "../../../../../utils/groupMappers";

export function getGroupById(groupId) {
  return GROUPS_DUMMY.find((g) => g.id === groupId) || null;
}

export function buildGroupDetailView(group) {
  if (!group) return null;
  if (group.summary || group.information || Array.isArray(group.teams)) {
    return mapApiGroupToDetailView(group);
  }
  return {
    id: group.id,
    name: group.name,
    status: group.status,
    createdDisplay: group.createdDisplay || group.createdDate,
    stats: {
      totalTeams: group.totalTeams ?? 0,
      totalAgents: group.totalAgents ?? 0,
      totalChats: group.totalChats ?? 0,
      totalTickets: group.totalTickets ?? 0,
    },
    teams: group.teams || [],
  };
}
